<div ng-class="{'ontario-row input-div' : !editApprovedMode}">
  <div ng-class="{'ontario-column ontario-small-12 ontario-large-12' : !editApprovedMode}">
    @if (!editApprovedMode && !soseMode) {
      <div>
        <h3 class="border-bottom">{{'BusinessInfoForm.Title' | translate}}</h3>
      </div>
      <div><b>{{'BusinessInfoForm.Description' | translate}}</b></div>
      <br>
      }

      <form [formGroup]="businessInfoForm">
        @if (soseMode) {
          <div class="row ontario-row">
            <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
              <mat-label class="input-label"><span class="required-field">{{ 'ApplicationForNewSoseRecognition.ApplicantInformation.BusinessLegalName' | translate}}</span></mat-label>
              <input type="text" class='input-text' matInput formControlName="LegalName"
                [class.disabled]="editApprovedMode" [readonly]="editApprovedMode" maxlength="256"
                placeholder="{{'Business.SoseLegalNamePlaceHolder' | translate}}" />
              </div>
              @if (showErrorsOverride || (businessInfoForm.controls['LegalName'].invalid &&  businessInfoForm.controls['LegalName'].errors &&
                (businessInfoForm.controls['LegalName'].dirty || businessInfoForm.controls['LegalName'].touched))) {
                <div class="form-field-error ontario-column ontario-small-12"
                  >
                  @if (businessInfoForm.controls['LegalName'].hasError('required')) {
                    <mat-error>
                      {{'Validation.Business.SoseLegalNameRequired' | translate}}
                    </mat-error>
                  }
                  @if (businessInfoForm.controls['LegalName'].hasError('maxlength')) {
                    <mat-error>
                      {{'Validation.Business.SoseLegalNameMaxLength' | translate}}
                    </mat-error>
                  }
                </div>
              }
            </div>
            <div class="row ontario-row">
              <div class="tp-input-row top-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
                <mat-label class="input-label">
                  <span class="required-field first-required">{{ 'ApplicationForNewSoseRecognition.ApplicantInformation.OperatingName' | translate}}</span>
                </mat-label>
                <input type="text" class='input-text' matInput formControlName="OperatingName"
                  [class.disabled]="editApprovedMode" [readonly]="editApprovedMode" maxlength="256"
                  placeholder="{{'Business.SoseOperatingNamePlaceHolder' | translate}}" />
                </div>
                @if (showErrorsOverride || (businessInfoForm.controls['OperatingName'].invalid &&  businessInfoForm.controls['OperatingName'].errors &&
                  (businessInfoForm.controls['OperatingName'].dirty || businessInfoForm.controls['OperatingName'].touched))) {
                  <div class="form-field-error ontario-column ontario-small-12"
                    >
                    @if (businessInfoForm.controls['OperatingName'].hasError('required')) {
                      <mat-error>
                        {{'Validation.Business.SoseOperatingNameRequired' | translate}}
                      </mat-error>
                    }
                    @if (businessInfoForm.controls['OperatingName'].hasError('maxlength')) {
                      <mat-error>
                        {{'Validation.Business.SoseOperatingNameMaxLength' | translate}}
                      </mat-error>
                    }
                  </div>
                }
              </div>
            } @else {
              <div class="row ontario-row">
                <div class="tp-input-row top-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
                  <mat-label class="input-label">
                    <span class="required-field first-required">{{'Business.OperatingName' | translate}}</span>
                  </mat-label>
                  <input type="text" class='input-text' matInput formControlName="OperatingName"
                    [class.disabled]="editApprovedMode" [readonly]="editApprovedMode" maxlength="256"
                    placeholder="{{'Business.OperatingNamePlaceHolder' | translate}}" />
                  </div>
                  @if (showErrorsOverride || (businessInfoForm.controls['OperatingName'].invalid &&  businessInfoForm.controls['OperatingName'].errors &&
                    (businessInfoForm.controls['OperatingName'].dirty || businessInfoForm.controls['OperatingName'].touched))) {
                    <div class="form-field-error ontario-column ontario-small-12"
                      >
                      @if (businessInfoForm.controls['OperatingName'].hasError('required')) {
                        <mat-error>
                          {{'Validation.Business.OperatingNameRequired' | translate}}
                        </mat-error>
                      }
                      @if (businessInfoForm.controls['OperatingName'].hasError('maxlength')) {
                        <mat-error>
                          {{'Validation.Business.OperatingNameMaxLength' | translate}}
                        </mat-error>
                      }
                    </div>
                  }
                </div>
                <div class="row ontario-row">
                  <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
                    <mat-label class="input-label"><span class="required-field">{{ 'Business.LegalName' | translate}}</span></mat-label>
                    <input type="text" class='input-text' matInput formControlName="LegalName"
                      [class.disabled]="editApprovedMode" [readonly]="editApprovedMode" maxlength="256"
                      placeholder="{{'Business.LegalNamePlaceHolder' | translate}}" />
                    </div>
                    @if (showErrorsOverride || (businessInfoForm.controls['LegalName'].invalid &&  businessInfoForm.controls['LegalName'].errors &&
                      (businessInfoForm.controls['LegalName'].dirty || businessInfoForm.controls['LegalName'].touched))) {
                      <div class="form-field-error ontario-column ontario-small-12"
                        >
                        @if (businessInfoForm.controls['LegalName'].hasError('required')) {
                          <mat-error>
                            {{'Validation.Business.LegalNameRequired' | translate}}
                          </mat-error>
                        }
                        @if (businessInfoForm.controls['LegalName'].hasError('maxlength')) {
                          <mat-error>
                            {{'Validation.Business.LegalNameMaxLength' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                  </div>
                }
                <div class="row ontario-row">
                  <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5 spinner-col">
                    <mat-label class="input-label">
                      <span [class]="{'required-field' : soseMode}">{{ (soseMode ? 'ApplicationForNewSoseRecognition.ApplicantInformation.BusinessNumber' : 'Business.BusinessNumber') | translate}}</span>
                      <app-tooltip [tooltipText]="'Business.BusinessNumber' | translate"></app-tooltip>
                    </mat-label>
                    <input type="text" mask="000000000" class='input-text' matInput formControlName="businessNumber"
                      placeholder="{{ (soseMode ? 'Business.SoseBusinessNumberPlaceHolder' : 'Business.BusinessNumberPlaceHolder') | translate}}" />
                      @if (bn9CallInProgress) {
                        <mat-spinner aria-label="spinner" [diameter]="30" class="bn9-spinner"></mat-spinner>
                      }
                    </div>
                    @if (showErrorsOverride || isValidBN9 === false || (businessInfoForm.controls['businessNumber'].invalid && businessInfoForm.controls['businessNumber'].errors &&
                      (businessInfoForm.controls['businessNumber'].dirty || businessInfoForm.controls['businessNumber'].touched))) {
                      <div class="form-field-error ontario-column ontario-small-12"
                        >
                        @if (businessInfoForm.controls['businessNumber'].hasError('required')) {
                          <mat-error>
                            {{ (soseMode ? 'Validation.Business.SoseBusinessNumberRequired' : 'Validation.Business.BusinessNumberRequired') | translate }}
                          </mat-error>
                        }
                        @if (businessInfoForm.controls['businessNumber'].hasError('maxlength')) {
                          <mat-error>
                            {{'Validation.Business.BusinessNumberMaxLength' | translate}}
                          </mat-error>
                        }
                        @if (businessInfoForm.controls['businessNumber'].hasError('pattern') || (isValidBN9 === false && !bn9CallInProgress)) {
                          <mat-error>
                            {{'Validation.Business.BusinessNumberPattern' | translate}}
                          </mat-error>
                        }
                      </div>
                    }
                  </div>
                  @if (!soseMode) {
                    <div class="row ontario-row">
                      <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
                        <mat-label class="input-label">
                          <span class="required-field">{{'Business.BusinessType' | translate}}</span>
                        </mat-label>
                        <input type="text" class='input-text' matInput formControlName="businessType"
                          placeholder="{{'Business.BusinessTypePlaceHolder' | translate}}" />
                        </div>
                        @if (showErrorsOverride || (businessInfoForm.controls['businessType'].invalid &&  businessInfoForm.controls['businessType'].errors &&
                          (businessInfoForm.controls['businessType'].dirty || businessInfoForm.controls['businessType'].touched))) {
                          <div class="form-field-error ontario-column ontario-small-12"
                            >
                            @if (businessInfoForm.controls['businessType'].hasError('required')) {
                              <mat-error>
                                {{'Validation.Business.BusinessTypeRequired' | translate}}
                              </mat-error>
                            }
                          </div>
                        }
                      </div>
                    }
                    <div class="row ontario-row">
                      <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
                        <mat-label class="input-label">
                          <span [class]="{'required-field' : soseMode}">{{ (soseMode ? 'ApplicationForNewSoseRecognition.ApplicantInformation.WSIBAccountNumber' : 'Business.WSIBAccountNumber') | translate}}</span>
                          <app-tooltip [tooltipText]="'Business.WSIBAccountNumber' | translate">
                          </app-tooltip>
                        </mat-label>
                        <input type="text" class='input-text' matInput formControlName="wsibAccountNumber" [maxLength]="50" mask="0000000"
                          placeholder="{{'Business.WSIBAccountNumberPlaceHolder' | translate}}" />
                        </div>
                        @if (showErrorsOverride || isValidBN9 === false || (businessInfoForm.controls['wsibAccountNumber'].invalid && businessInfoForm.controls['wsibAccountNumber'].errors &&
                          (businessInfoForm.controls['wsibAccountNumber'].dirty || businessInfoForm.controls['wsibAccountNumber'].touched))) {
                          <div class="form-field-error ontario-column ontario-small-12"
                            >
                            @if (businessInfoForm.controls['wsibAccountNumber'].hasError('required')) {
                              <mat-error>
                                {{'Validation.Business.WSIBAccountNumberRequired' | translate}}
                              </mat-error>
                            }
                            @if (businessInfoForm.controls['wsibAccountNumber'].hasError('pattern')) {
                              <mat-error>
                                {{'Validation.Business.WSIBAccountNumberPattern' | translate}}
                              </mat-error>
                            }
                          </div>
                        }
                      </div>

                      @if (soseMode) {
                        <div>
                          <div class="ontario-margin-top-24-! ontario-column form-input-div ontario-small-12 ontario-medium-4">
                            <label for="OrganizationPhoneNumber"><span class="required-field">{{'ApplicationForNewSoseRecognition.ApplicantInformation.OrganizationPhoneNumber' | translate }}</span></label>
                            <input formControlName="OrganizationPhoneNumber" name="OrganizationPhoneNumber" maxlength="20" id="OrganizationPhoneNumber"
                              required type="text" mask="000-000-0000" placeholder="{{'Contact.SosePhoneTooltip' | translate }}"
                              class='input-text' matInput />
                              @if (showErrorsOverride || (businessInfoForm.controls['OrganizationPhoneNumber'].invalid && businessInfoForm.controls['OrganizationPhoneNumber'].errors &&
                                (businessInfoForm.controls['OrganizationPhoneNumber'].dirty || businessInfoForm.controls['OrganizationPhoneNumber'].touched))) {
                                <div>
                                  @if (businessInfoForm.controls['OrganizationPhoneNumber'].hasError('required')) {
                                    <mat-error>
                                      {{'Validation.Phone.SoseRequired' | translate}}
                                    </mat-error>
                                  }
                                  @if (businessInfoForm.controls['OrganizationPhoneNumber'].hasError('pattern')) {
                                    <mat-error>
                                      {{'Validation.Phone.Pattern' | translate}}
                                    </mat-error>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                          <div class="ontario-row">
                            <div class="ontario-margin-top-24-! ontario-column form-input-div ontario-medium-2">
                              <label for="Extension">{{'EmployerPortal.Extension' | translate }}</label>
                              <input formControlName="Extension" name="Extension" maxlength="9" id="Extension"
                                type="number"  class='input-text' matInput />
                              </div>
                            </div>
                          }

                          <div class="row ontario-row">
                            <div class="ontario-small-12 ontario-medium-6 ontario-column ontario-large-5 heading">
                              <label>{{ (soseMode ? 'ApplicationForNewSoseRecognition.ApplicantInformation.MailingAddress' : 'Business.BusinessPrimaryAddress') | translate}}</label>
                            </div>
                          </div>

                          <div class="row ontario-row">
                            @if (showSameMailing) {
                              <div class="tp-input-row">
                                <app-checkbox [name]="'Address.SameAddressOption' | translate"
                                  [checked]="businessInfoForm.controls['isMailingAndBusinessAddressSame'].value"
                                  (checkedChange)="businessInfoForm.controls['isMailingAndBusinessAddressSame'].setValue($event); this.sameAddressOptionChanged.emit($event)">
                                </app-checkbox>
                              </div>
                            }
                          </div>

                          <div class="row ontario-row">
                            <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
                              <app-predictive-address-search #busAddress [formGroupName]="'AddressForm'"></app-predictive-address-search>
                              @if (showErrorsOverride ||
                                (businessInfoForm.get('AddressForm')!.invalid && businessInfoForm.get('AddressForm')!.errors &&
                                (businessInfoForm.get('AddressForm')!.dirty || businessInfoForm.get('AddressForm')!.touched))) {
                                <div class="margin-top ontario-small-12">
                                  @if (businessInfoForm.get('AddressForm')!.invalid) {
                                    <mat-error>
                                      {{'Validation.StreetAddress.Required' | translate}}
                                    </mat-error>
                                  }
                                </div>
                              }
                            </div>
                          </div>

                          <div class="row ontario-row">
                            <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
                              <mat-label class="input-label"><span>{{'Address.POBox' | translate}}</span></mat-label>
                              <input type="text" class='input-text' matInput formControlName="poBox" [readonly]="isReadOnlyMode" [class.readonly]="isReadOnlyMode"
                                [placeholder]="isReadOnlyMode ? '' : 'Address.POBoxPlaceHolder' | translate" />
                              </div>
                            </div>

                            <div class="row ontario-row">
                              <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5">
                                <mat-label class="input-label">
                                  {{(soseMode ? 'ApplicationForNewSoseRecognition.ApplicantInformation.OrganizationWebsite' : 'Business.CompanyWebsite') | translate}}
                                </mat-label>
                                <input type="text" class='input-text' matInput formControlName="companyWebSite"
                                  placeholder="{{ (soseMode ? 'Business.SoseCompanyWebsitePlaceHolder' : 'Business.CompanyWebsitePlaceHolder') | translate}}" />
                                </div>
                                @if (showErrorsOverride || (businessInfoForm.controls['companyWebSite'].invalid &&  businessInfoForm.controls['companyWebSite'].errors &&
                                  (businessInfoForm.controls['companyWebSite'].dirty || businessInfoForm.controls['companyWebSite'].touched))) {
                                  <div class="form-field-error ontario-column ontario-small-12"
                                    >
                                    @if (businessInfoForm.controls['companyWebSite'].hasError('pattern')) {
                                      <mat-error>
                                        {{(soseMode ? 'Validation.Business.SoseCompanyWebsitePattern' : 'Validation.Business.CompanyWebsitePattern') | translate}}
                                      </mat-error>
                                    }
                                  </div>
                                }
                              </div>

                              @if (!soseMode) {
                                <div class="row ontario-row">
                                  <div class="tp-input-row ontario-small-12 ontario-medium-6 ontario-column ontario-large-5 checkbox-list">
                                    <mat-label class="input-label">
                                      <span class="required-field">{{'Business.PreferredMethodOfCorrespondence' | translate}}</span>
                                      <app-tooltip [tooltipText]="'Business.PreferredMethodOfCorrespondence' | translate"></app-tooltip>
                                    </mat-label>
                                    @for (option of correspondencePreferenceOptions; track option) {
                                      <app-checkbox #email
                                        id="emailOptionComponent" [name]="currentLang == 'en' ? option.Value : option.ValueFr"
                                        [checked]="businessInfoForm.controls['CorrespondenceOption'].value.indexOf(option.LookupObjectId) > -1"
                                        (checkedChange)="this.setCorrespondenceOption(option.LookupObjectId)">
                                      </app-checkbox>
                                    }
                                  </div>
                                  @if (showErrorsOverride || (businessInfoForm.controls['CorrespondenceOption'].invalid &&  businessInfoForm.controls['CorrespondenceOption'].errors &&
                                    (businessInfoForm.controls['CorrespondenceOption'].dirty || businessInfoForm.controls['CorrespondenceOption'].touched))) {
                                    <div class="form-field-error ontario-column ontario-small-12"
                                      >
                                      @if (businessInfoForm.controls['CorrespondenceOption'].hasError('required')) {
                                        <mat-error>
                                          {{'Validation.Business.EmailOptionRequired' | translate}}
                                        </mat-error>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </form>
                          </div>
                        </div>
